import { createSlice } from '@reduxjs/toolkit'
var startScreen=localStorage.getItem("activeScreen");
const initialState = {
  value: startScreen?startScreen:"Main",
  activeProcess: localStorage.getItem("activeProcess"),
  activeState:localStorage.getItem("activeState"),
  activeInstance:localStorage.getItem("activeInstance"),
  action: "",
  validFunctions: {},
}

export const appStateSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
	setAction: (state,action) => {
//		console.log(action);
		state.action=action.payload;
		},
	setValidFunctions: (state, actions) => {
		//console.log(actions.payload);
		state.validFunctions=actions.payload;
		},
	setFormDataMerge: (state, actions)=> {
		//console.log(actions.payload);
		state.formDataMerge=actions.payload;
		},
	setConversionTable: (state,actions)=>{
		state.conversionTable=actions.payload;
		},
	}
})


export const { setConversionTable,setAction,setValidFunctions,setFormDataMerge } = appStateSlice.actions
export default appStateSlice.reducer